import { render, staticRenderFns } from "./GraficBar.vue?vue&type=template&id=883ca87a&scoped=true"
import script from "./GraficBar.vue?vue&type=script&lang=js"
export * from "./GraficBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883ca87a",
  null
  
)

export default component.exports